export default __webpack_public_path__ + "static/media/headerImgDeco2.8922a6e2.png";